export default __webpack_public_path__ + "static/media/snowflake.55b96f65.svg";